function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM20 12C20 12.7 19.9 13.4 19.7 14C19.1 12.5 18.1 10.9 16.7 9.3L18.5 7.5C19.5 8.8 20 10.3 20 12ZM6.5 6.5C7.8 6.5 10.1 7.3 12.5 9.4L9.3 12.6C7.1 9.8 6.5 7.5 6.5 6.5ZM14.6 11.5C16.9 14.2 17.5 16.5 17.5 17.5C16.2 17.5 13.9 16.7 11.5 14.6L14.6 11.5ZM16.5 5.4L14.6 7.3C13 5.9 11.4 4.9 9.9 4.3C10.6 4.1 11.2 4 11.9 4C13.7 4 15.2 4.5 16.5 5.4ZM4 12C4 11.3 4.1 10.6 4.3 10C4.9 11.5 5.9 13.1 7.3 14.7L5.5 16.5C4.5 15.2 4 13.7 4 12ZM7.5 18.6L9.4 16.7C11 18.1 12.6 19.1 14.1 19.7C13.4 19.9 12.8 20 12.1 20C10.3 20 8.8 19.5 7.5 18.6V18.6Z",
  fill: "#03363D"
});

var SvgGlobe = function SvgGlobe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlobe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Globe.bd095ce1.svg";
export { ForwardRef as ReactComponent };